import { render } from "./RegistrationPersonData.vue?vue&type=template&id=58ab97b0&scoped=true&ts=true"
import script from "./RegistrationPersonData.vue?vue&type=script&lang=ts"
export * from "./RegistrationPersonData.vue?vue&type=script&lang=ts"

import "./RegistrationPersonData.vue?vue&type=style&index=0&id=58ab97b0&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ab97b0"]])

export default __exports__